/*
  Hiërarchische filterwaarden ("Bird > Owl").
  Binnen één filter geldt OF, dus een hoofdgroep plus een van zijn soorten tegelijk
  aangevinkt is dubbel. Vink je de hoofdgroep aan, dan gaan de vinkjes bij de soorten
  eraf; vink je een soort aan, dan gaat het vinkje bij de hoofdgroep eraf.
  Draait in de capture-fase, vóór Dawn het formulier (vertraagd) verstuurt.
*/
(function () {
  if (window.facetTreeInitialized) return;
  window.facetTreeInitialized = true;

  document.addEventListener(
    'input',
    function (event) {
      var input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'checkbox' || !input.checked) return;
      var form = input.form || input.closest('form');
      if (!form) return;

      var others = form.querySelectorAll('input[type="checkbox"]');
      var root = input.getAttribute('data-tree-root');
      var parent = input.getAttribute('data-tree-parent');

      others.forEach(function (other) {
        if (other === input || other.name !== input.name || !other.checked) return;
        if (root !== null && other.getAttribute('data-tree-parent') === root) other.checked = false;
        if (parent !== null && other.getAttribute('data-tree-root') === parent) other.checked = false;
      });
    },
    true
  );
})();
